import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "filterable-list__list-item",
    tabindex: "-1"
};
const _hoisted_2 = { class: "filterable-list__list-item-meta" };
const _hoisted_3 = { class: "filterable-list__list-item-meta-category" };
import { useConfig } from "../features";
import ImageContainer from "./NewsListItemImageContainer.vue";
import ImagePicture from "./NewsListItemImagePicture.vue";
import DefaultImage from "./NewsListItemImageDefault.vue";
import ImageEventDate from "./NewsListItemImageEventDates.vue";
import ItemContent from "./NewsListItemContent.vue";
import ItemContentDates from "./NewsListItemContentDate.vue";
import ItemContentLink from "./NewsListItemContentLink.vue";
import ItemContentTimeAddress from "./NewsListItemContentTimeAddress.vue";
import ItemContentDescription from "./NewsListItemContentDescription.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItem',
    props: {
        item: {}
    },
    setup(__props) {
        const { item } = __props;
        const { thema } = useConfig();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createVNode(ImageContainer, { category: _unref(thema) }, {
                    default: _withCtx(() => [
                        _createVNode(ImagePicture, {
                            image: _ctx.item?.image
                        }, {
                            default: _withCtx(() => [
                                _createVNode(DefaultImage)
                            ], undefined, true),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["image"]),
                        (_unref(thema) === 'events')
                            ? (_openBlock(), _createBlock(ImageEventDate, {
                                key: 0,
                                item: _ctx.item
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["category"]),
                _createVNode(ItemContent, { category: _unref(thema) }, {
                    default: _withCtx(() => [
                        _createElementVNode("em", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item?.categoryHeadline) + _toDisplayString('\xa0'), 1 /* TEXT */),
                            _createVNode(ItemContentDates, { item: _ctx.item }, null, 8 /* PROPS */, ["item"])
                        ]),
                        _createVNode(ItemContentLink, {
                            category: _unref(thema),
                            link: _ctx.item?.link
                        }, null, 8 /* PROPS */, ["category", "link"]),
                        _createVNode(ItemContentTimeAddress, {
                            "item-address": _ctx.item?.address,
                            "item-time": _ctx.item?.time
                        }, null, 8 /* PROPS */, ["item-address", "item-time"]),
                        _createVNode(ItemContentDescription, null, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.item?.description), 1 /* TEXT */)
                            ], undefined, true),
                            _: 1 /* STABLE */
                        })
                    ], undefined, true),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["category"])
            ]));
        };
    }
});
